var backButton = '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#0CED9F"/><path d="M29 21C29.5523 21 30 20.5523 30 20C30 19.4477 29.5523 19 29 19V20V21ZM13.2929 19.2929C12.9024 19.6834 12.9024 20.3166 13.2929 20.7071L19.6569 27.0711C20.0474 27.4616 20.6805 27.4616 21.0711 27.0711C21.4616 26.6805 21.4616 26.0474 21.0711 25.6569L15.4142 20L21.0711 14.3431C21.4616 13.9526 21.4616 13.3195 21.0711 12.9289C20.6805 12.5384 20.0474 12.5384 19.6569 12.9289L13.2929 19.2929ZM29 20V19L14 19V20V21L29 21V20Z" fill="#2B2B2B"/></svg></div>';
var nextButton = '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="#0CED9F"/><path d="M11 21C10.4477 21 10 20.5523 10 20C10 19.4477 10.4477 19 11 19V20V21ZM26.7071 19.2929C27.0976 19.6834 27.0976 20.3166 26.7071 20.7071L20.3431 27.0711C19.9526 27.4616 19.3195 27.4616 18.9289 27.0711C18.5384 26.6805 18.5384 26.0474 18.9289 25.6569L24.5858 20L18.9289 14.3431C18.5384 13.9526 18.5384 13.3195 18.9289 12.9289C19.3195 12.5384 19.9526 12.5384 20.3431 12.9289L26.7071 19.2929ZM11 20V19L26 19V20V21L11 21V20Z" fill="#2B2B2B"/></svg></div>';
$(document).ready(function(){
    $('.transform-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '1px',
        arrows: true,
        dots: true,
        speed: 300,
        infinite: true,
        prevArrow: backButton,
        nextArrow: nextButton,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    centerMode:true,
                    centerPadding: '60px',
                    arrows:false,
                }
            }
        ]
    });
    $(function(){
    let $slider = $('.hero-slider');
    $slider.on('afterChange init', function(e, slick, i){
        let s = i || 0;
        $('.custom-prev').toggleClass('disabled', s === 0);
        $('.custom-next').toggleClass('disabled', s === slick.slideCount - 1);
    });
    $slider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        prevArrow: '.custom-prev',
        nextArrow: '.custom-next'
    });
    });
    (function ($2) {
        var methods = {
            init: function (options) {
                var o = $2.extend(
                    {
                        items: 1,
                        itemsOnPage: 1,
                        pages: 0,
                        displayedPages: 5,
                        edges: 2,
                        currentPage: 1,
                        hrefTextPrefix: "#page-",
                        hrefTextSuffix: "",
                        prevText: "Prev",
                        nextText: "Next",
                        ellipseText: "&hellip;",
                        cssStyle: "light-theme",
                        selectOnClick: !0,
                        onPageClick: function (pageNumber, event) {},
                        onInit: function () {},
                    },
                    options || {}
                ),
                self = this;

                o.pages = o.pages ? o.pages : Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1;
                o.currentPage = o.currentPage - 1;
                o.halfDisplayed = o.displayedPages / 2;

                return (
                    this.each(function () {
                        self.addClass(o.cssStyle + " simple-pagination").data("pagination", o);
                        methods._draw.call(self);
                    }),
                    o.onInit(),
                    this
                );
            },

            selectPage: function (page) {
                methods._selectPage.call(this, page - 1);
                return this;
            },

            prevPage: function () {
                var o = this.data("pagination");
                if (o.currentPage > 0) methods._selectPage.call(this, o.currentPage - 1);
                return this;
            },

            nextPage: function () {
                var o = this.data("pagination");
                if (o.currentPage < o.pages - 1) methods._selectPage.call(this, o.currentPage + 1);
                return this;
            },

            getPagesCount: function () {
                return this.data("pagination").pages;
            },

            getCurrentPage: function () {
                return this.data("pagination").currentPage + 1;
            },

            destroy: function () {
                this.empty();
                return this;
            },

            redraw: function () {
                methods._draw.call(this);
                return this;
            },

            disable: function () {
                var o = this.data("pagination");
                o.disabled = !0;
                this.data("pagination", o);
                methods._draw.call(this);
                return this;
            },

            enable: function () {
                var o = this.data("pagination");
                o.disabled = !1;
                this.data("pagination", o);
                methods._draw.call(this);
                return this;
            },

            updateItems: function (newItems) {
                var o = this.data("pagination");
                o.items = newItems;
                o.pages = Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1;
                this.data("pagination", o);
                methods._draw.call(this);
            },
            _draw: function () {
                var o = this.data("pagination"),
                    interval = methods._getInterval(o),
                    i;

                methods.destroy.call(this);

                var $panel = this.prop("tagName") === "UL" ? this : $('<ul></ul>').appendTo(this);
                methods._appendItem.call(this, o.currentPage - 1, {
                    text: o.prevText,
                    classes: o.currentPage === 0 ? "prev disabled" : "prev"
                });

                if (interval.start > 0 && o.edges > 0) {
                    var end = Math.min(o.edges, interval.start);
                    for (i = 0; i < end; i++) methods._appendItem.call(this, i);

                    if (o.edges < interval.start && interval.start - o.edges != 1)
                        $panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + "</span></li>");
                    else if (interval.start - o.edges == 1)
                        methods._appendItem.call(this, o.edges);
                }

                for (i = interval.start; i < interval.end; i++)
                    methods._appendItem.call(this, i);

                if (interval.end < o.pages && o.edges > 0) {
                    if (o.pages - o.edges > interval.end && o.pages - o.edges - interval.end != 1)
                        $panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + "</span></li>");
                    else if (o.pages - o.edges - interval.end == 1)
                        methods._appendItem.call(this, interval.end++);

                    var begin = Math.max(o.pages - o.edges, interval.end);
                    for (i = begin; i < o.pages; i++) methods._appendItem.call(this, i);
                }
                methods._appendItem.call(this, o.currentPage + 1, {
                    text: o.nextText,
                    classes: o.currentPage === o.pages - 1 ? "next disabled" : "next"
                });
            },

            _getInterval: function (o) {
                return {
                    start: Math.ceil(
                        o.currentPage > o.halfDisplayed
                            ? Math.max(Math.min(o.currentPage - o.halfDisplayed, o.pages - o.displayedPages), 0)
                            : 0
                    ),
                    end: Math.ceil(
                        o.currentPage > o.halfDisplayed
                            ? Math.min(o.currentPage + o.halfDisplayed, o.pages)
                            : Math.min(o.displayedPages, o.pages)
                    ),
                };
            },
            _appendItem: function (pageIndex, opts) {
                var self = this,
                    o = self.data("pagination"),
                    $link,
                    $linkWrapper = $2("<li></li>"),
                    $ul = self.find("ul");

                pageIndex = pageIndex < 0 ? 0 : pageIndex < o.pages ? pageIndex : o.pages - 1;

                var prevIcon =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M13.13 1.66683C13.4983 1.25526 13.4632 0.623064 13.0516 0.254786C12.64 -0.113492 12.0078 -0.0783957 11.6396 0.333175L12.3848 1L13.13 1.66683ZM1.38477 13.2931L0.639552 12.6263L0.000132322 13.3409L0.68727 14.0097L1.38477 13.2931ZM11.6873 24.7166L12.4039 25.4141L13.7989 23.9809L13.0823 23.2834L12.3848 24L11.6873 24.7166ZM12.3848 1L11.6396 0.333175L0.639552 12.6263L1.38477 13.2931L2.12998 13.9599L13.13 1.66683L12.3848 1ZM1.38477 13.2931L0.68727 14.0097L11.6873 24.7166L12.3848 24L13.0823 23.2834L2.08226 12.5765L1.38477 13.2931Z" fill="#E6E6DD"/></svg>';

                var nextIcon =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M0.668848 1.66683C0.30057 1.25526 0.335666 0.623064 0.747236 0.254786C1.15881 -0.113492 1.791 -0.0783957 2.15928 0.333175L1.41406 1L0.668848 1.66683ZM12.4141 13.2931L13.1593 12.6263L13.7987 13.3409L13.1116 14.0097L12.4141 13.2931ZM2.11156 24.7166L1.39497 25.4141L-2.28882e-05 23.9809L0.716567 23.2834L1.41406 24L2.11156 24.7166ZM1.41406 1L2.15928 0.333175L13.1593 12.6263L12.4141 13.2931L11.6688 13.9599L0.668848 1.66683L1.41406 1ZM12.4141 13.2931L13.1116 14.0097L2.11156 24.7166L1.41406 24L0.716567 23.2834L11.7166 12.5765L12.4141 13.2931Z" fill="#E6E6DD"/></svg>';

                var options = $2.extend({ text: pageIndex + 1, classes: "" }, opts || {});

                let isPrev = options.classes.includes("prev");
                let isNext = options.classes.includes("next");
                let isNumber = !isPrev && !isNext;

                if (isPrev) $linkWrapper.addClass("pagination-prev-item");
                if (isNext) $linkWrapper.addClass("pagination-next-item");
                if (isNumber) $linkWrapper.addClass("pagination-number-item");

                if (isPrev) options.text = prevIcon;
                if (isNext) options.text = nextIcon;
                let isDisabled = options.classes.includes("disabled") || o.disabled;

                if (isDisabled || pageIndex == o.currentPage) {
                    if (isDisabled) $linkWrapper.addClass("disabled");
                    else $linkWrapper.addClass("active");

                    $link = $2(
                        '<span class="' +
                            (isPrev
                                ? "pagination-prev"
                                : isNext
                                ? "pagination-next"
                                : "pagination-number") +
                            '">' +
                            options.text +
                            "</span>"
                    );
                } else {
                    $link = $2(
                        '<a href="' +
                            o.hrefTextPrefix +
                            (pageIndex + 1) +
                            o.hrefTextSuffix +
                            '" class="' +
                            (isPrev
                                ? "pagination-prev"
                                : isNext
                                ? "pagination-next"
                                : "pagination-number") +
                            '">' +
                            options.text +
                            "</a>"
                    );

                    $link.click(function (event) {
                        return methods._selectPage.call(self, pageIndex, event);
                    });
                }

                $linkWrapper.append($link);
                if ($ul.length) $ul.append($linkWrapper);
                else self.append($linkWrapper);
            },

            _selectPage: function (pageIndex, event) {
                var o = this.data("pagination");
                o.currentPage = pageIndex;

                if (o.selectOnClick) methods._draw.call(this);
                o.onPageClick(pageIndex + 1, event);
                return this;
            },
        };

        $2.fn.pagination = function (method) {
            if (methods[method] && method.charAt(0) != "_")
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));

            if (typeof method == "object" || !method) return methods.init.apply(this, arguments);

            $2.error("Method " + method + " does not exist on jQuery.pagination");
        };
    })(jQuery);
    var items = $(".list-wrapper .list-item"),
    numItems = items.length,
    perPage = 6;

    items.slice(perPage).hide();

    if (numItems > 0)
    $("#pagination-container").pagination({
        items: numItems,
        itemsOnPage: perPage,

        prevText:
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M13.13 1.66683C13.4983 1.25526 13.4632 0.623064 13.0516 0.254786C12.64 -0.113492 12.0078 -0.0783957 11.6396 0.333175L12.3848 1L13.13 1.66683ZM1.38477 13.2931L0.639552 12.6263L0.000132322 13.3409L0.68727 14.0097L1.38477 13.2931ZM11.6873 24.7166L12.4039 25.4141L13.7989 23.9809L13.0823 23.2834L12.3848 24L11.6873 24.7166ZM12.3848 1L11.6396 0.333175L0.639552 12.6263L1.38477 13.2931L2.12998 13.9599L13.13 1.66683L12.3848 1ZM1.38477 13.2931L0.68727 14.0097L11.6873 24.7166L12.3848 24L13.0823 23.2834L2.08226 12.5765L1.38477 13.2931Z" fill="#E6E6DD"/></svg>',

        nextText:
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M0.668848 1.66683C0.30057 1.25526 0.335666 0.623064 0.747236 0.254786C1.15881 -0.113492 1.791 -0.0783957 2.15928 0.333175L1.41406 1L0.668848 1.66683ZM12.4141 13.2931L13.1593 12.6263L13.7987 13.3409L13.1116 14.0097L12.4141 13.2931ZM2.11156 24.7166L1.39497 25.4141L-2.28882e-05 23.9809L0.716567 23.2834L1.41406 24L2.11156 24.7166ZM1.41406 1L2.15928 0.333175L13.1593 12.6263L12.4141 13.2931L11.6688 13.9599L0.668848 1.66683L1.41406 1ZM12.4141 13.2931L13.1116 14.0097L2.11156 24.7166L1.41406 24L0.716567 23.2834L11.7166 12.5765L12.4141 13.2931Z" fill="#E6E6DD"/></svg>',

        onPageClick: function (pageNumber) {
            var showFrom = perPage * (pageNumber - 1),
                showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
        },
    });
    window.onload = function() {
        var local = window.location.href;
        console.log("local", local);
        if (local == "https://thrive-over-30.myshopify.com/blogs/news" || local == "https://thrive-over-30.myshopify.com/blogs/news/")
            $(".article_blog_nev .all.link_blog").addClass("active");
        else if (local == "https://thrive-over-30.myshopify.com/blogs/news" || local == "https://thrive-over-30.myshopify.com/blogs/news/")
            $(".article_blog_nev .all.link_blog").addClass("active");
        else {
            var tags = localStorage.getItem("tag");
            $(".article_blog_nev .link_blog").removeClass("active"),
            $('.article_blog_nev .link_blog[data-handle="' + tags + '"]').addClass("active");
        
        } 
    }
    $(document).on("click", ".filter-custom .all", function () {
        $(".filter-custom .link_blog").removeClass("active"),
            $(this).addClass("active"),
            $(".upper-sec").html(" "),
            localStorage.setItem("tag", "all");
        var newurl = "/blogs/news/";
        $.ajax({
            type: "GET",
            url: newurl,
            success: function (res) {
                var gethtml = res,
                    getmain = $(gethtml).find(".upper-sec").html();
                $(".upper-sec").html(getmain), history.pushState(null, null, newurl);
                var items2 = $(".list-wrapper .list-item"),
                    numItems2 = items2.length,
                    perPage2 = 6;
                $("#pagination-container").removeClass("page-hide"),
                    items2.slice(perPage2).hide(),
                    $("#pagination-container").pagination({
                        items: numItems2,
                        itemsOnPage: perPage2,
                        prevText: "&laquo;",
                        nextText: "&raquo;",
                        onPageClick: function (pageNumber) {
                            var showFrom = perPage2 * (pageNumber - 1),
                                showTo = showFrom + perPage2;
                            items2.hide().slice(showFrom, showTo).show();
                        },
                    });
            },
        });
    }),
    $(document).on("click", ".filter-custom .tags", function () {
        $(".filter-custom .link_blog").removeClass("active"), $(this).addClass("active");
        var tag = $(this).attr("data-handle");
        localStorage.setItem("tag", tag);
        var newurl = "/blogs/news/tagged/" + tag;
        $.ajax({
            type: "GET",
            url: newurl,
            success: function (res) {
                var gethtml = res,
                    getmain = $(gethtml).find(".upper-sec").html();
                $(".upper-sec").html(getmain), history.pushState(null, null, newurl);
                var items2 = $(".list-wrapper .list-item"),
                    numItems2 = items2.length,
                    perPage2 = 6;
                items2.slice(perPage2).hide(),
                    numItems2 > 0
                        ? $("#pagination-container").removeClass("page-hide")
                        : $("#pagination-container").addClass("page-hide"),
                    $("#pagination-container").pagination({
                        items: numItems2,
                        itemsOnPage: perPage2,
                        prevText: '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="26" viewBox="0 0 13 26" fill="none"><path opacity="0.5" d="M12.1019 1.63104C12.4504 1.20261 12.3856 0.572768 11.9572 0.224252C11.5288 -0.124263 10.8989 -0.0594767 10.5504 0.368957L11.3262 1L12.1019 1.63104ZM1.32617 13.2931L0.550424 12.6621L0.000202537 13.3385L0.595351 13.9757L1.32617 13.2931ZM10.5954 24.6826L11.2779 25.4134L12.7396 24.0483L12.057 23.3174L11.3262 24L10.5954 24.6826ZM11.3262 1L10.5504 0.368957L0.550424 12.6621L1.32617 13.2931L2.10192 13.9241L12.1019 1.63104L11.3262 1ZM1.32617 13.2931L0.595351 13.9757L10.5954 24.6826L11.3262 24L12.057 23.3174L2.05699 12.6105L1.32617 13.2931Z" fill="#E6E6DD"/></svg>',
                        nextText: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M0.668848 1.66683C0.30057 1.25526 0.335666 0.623064 0.747236 0.254786C1.15881 -0.113492 1.791 -0.0783957 2.15928 0.333175L1.41406 1L0.668848 1.66683ZM12.4141 13.2931L13.1593 12.6263L13.7987 13.3409L13.1116 14.0097L12.4141 13.2931ZM2.11156 24.7166L1.39497 25.4141L-2.28882e-05 23.9809L0.716567 23.2834L1.41406 24L2.11156 24.7166ZM1.41406 1L2.15928 0.333175L13.1593 12.6263L12.4141 13.2931L11.6688 13.9599L0.668848 1.66683L1.41406 1ZM12.4141 13.2931L13.1116 14.0097L2.11156 24.7166L1.41406 24L0.716567 23.2834L11.7166 12.5765L12.4141 13.2931Z" fill="#E6E6DD"/></svg>',
                        onPageClick: function (pageNumber) {
                            var showFrom = perPage2 * (pageNumber - 1),
                                showTo = showFrom + perPage2;
                            items2.hide().slice(showFrom, showTo).show();
                        },
                    });
            },
        });
    }),
    $(document).on("click", ".article_page .link_blog", function () {
        var value = $(this).text(),
            hr = (window.location.href = "/blogs/news/tagged/" + value);
        localStorage.setItem("tag", value);
    }),
    $(document).on("click", ".article_page .all", function () {
        var value = $(this).text(),
            hr = (window.location.href = "/blogs/news/");
    }),
    $(window).on("load", function () {
        var href = window.location.href;
        href.includes("news/") &&
            $("html, body").animate({ scrollTop: $("#bottom-section").offset().top - 200 }, 2e3);
    }),
    $(document).on("click", ".page-link", function () {
        $("html, body").animate({ scrollTop: $("#bottom-section").offset().top - 200 }, 1e3);
    });
});
